import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const RelatedLinks = ({ title = "Explore more", items = [] }) => {
  if (!items.length) return null;
  return (
    <section
      data-testid="related-links"
      className="relative py-16 sm:py-20 bg-gradient-to-b from-black via-zinc-950 to-black border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-8 bg-zinc-600" />
          <span className="text-[10px] font-bold uppercase tracking-[0.35em] text-zinc-400">{title}</span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((it, i) => (
            <motion.div
              key={it.to}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
            >
              <Link
                to={it.to}
                data-testid={`related-link-${it.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group block p-6 rounded-2xl bg-white/[0.03] border border-white/10 hover:border-brand-yellow/50 hover:bg-white/[0.06] hover:-translate-y-1 transition-all"
              >
                <div className="flex items-start justify-between mb-3">
                  <span className="text-[10px] uppercase tracking-[0.28em] text-brand-yellow font-bold">{it.tag}</span>
                  <ArrowUpRight className="text-zinc-500 group-hover:text-brand-yellow group-hover:rotate-12 transition-all" size={20} />
                </div>
                <h3 className="font-display text-2xl text-white tracking-wide leading-tight">{it.label}</h3>
                {it.desc && (
                  <p className="mt-2 text-xs text-zinc-400 leading-relaxed">{it.desc}</p>
                )}
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
